module.exports = __webpack_public_path__ + "static/media/04-CollectiveBCS.2c2712cc.gif";